// src/router/index.js
import { createWebHistory, createRouter } from "vue-router";
import HomePage from "@/views/HomePage.vue"; 
import ViewBook from "@/views/ViewBook.vue"; 
import ViewPuzzle from "@/views/ViewPuzzle.vue"; 
import HowToSolve from "@/views/HowToSolve.vue";

const routes = [
    { path: "/", name: "HomePage", component: HomePage },
    { path: "/books/:bookId", name: "ViewBook", component: ViewBook },     
    { path: "/puzzles/:puzzleId?", name: "ViewPuzzle", component: ViewPuzzle },
    { path: "/howtosolve", name: "HowToSolve", component: HowToSolve },
    
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;